import { dashboardRoute, homeRoute } from 'app/navigation/staticRoutes'
import cx from 'classnames'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { ReactComponent as PhraseePrimaryLogo } from 'common/icons/phraseeLogo/primary.svg'
import Link from 'common/typography/Link'
import AuthFooter from 'features/auth/components/Footer'

const MessageComponent = (props) => {
  const {
    isPageNotFound,
    isPageUnauthorized,
    isErrorStaticPage,
    textPrimary,
    textSecondary,
    shouldRenderCta,
    image,
    distributionChannel,
    projectId,
  } = props

  let refUrl: any = undefined
  if (shouldRenderCta) {
    refUrl = `/campaign?distributionChannel=${distributionChannel}
      &projectId=${projectId}`
  }

  const flags = useFlags()

  const homePageUrl = flags.showHomePage ? homeRoute.to : dashboardRoute.to

  const linkStyle = 'text-3xl hover:underline font-light text-orange-500'

  const pageNotFoundValues = {
    textPrimary: 'Well that was unlucky!',
    textSecondary: 'Page not found - error 404.',
    image: (
      <img
        className="absolute w-80 -left-8 hidden md:block"
        data-test-id="messageComponentImage"
        src="/images/eight-ball.svg"
        alt=""
      />
    ),
    shouldRenderCta: true,
    ctaText: (
      <>
        Try going to the{' '}
        <Link to={homePageUrl} className={linkStyle}>
          homepage
        </Link>{' '}
        or chat with us, we can fix just about anything 😉
      </>
    ),
    url: homePageUrl,
  }

  const pageUnauthorizedValues = {
    textPrimary: 'Tut-tut! You’re not authorized to view this page.',
    textSecondary: 'Either no authentication was provided or it was invalid.',
    image: (
      <>
        <img
          className="absolute w-96 -left-8 hidden lg:block"
          data-test-id="messageComponentImage"
          src="/images/pirate.svg"
          alt=""
        />
        <img
          className="absolute w-96 left-32 top-116 hidden lg:block"
          data-test-id="messageComponentImage"
          src="/images/speech-bubble.svg"
          alt=""
        />
      </>
    ),
    shouldRenderCta: true,
    ctaText: (
      <>
        Try going to the{' '}
        <Link to={homePageUrl} className={linkStyle}>
          homepage
        </Link>{' '}
        or{' '}
        <Link to="/" className={linkStyle}>
          login
        </Link>{' '}
        and try again.
      </>
    ),
    url: '/',
  }

  const pageType = isPageNotFound ? pageNotFoundValues : pageUnauthorizedValues

  const handleClick = () => {
    const { history } = props
    const pathToGo: any = isErrorStaticPage ? pageType.url : refUrl
    if (history.push && !pathToGo.includes('/users/')) {
      history.push(pathToGo)
    } else {
      window.location = pathToGo
    }
  }

  return (
    <div
      className="relative min-h-screen flex flex-col justify-center
      px-12 py-12 bg-warmGray-50  overflow-x-hidden"
    >
      {image ? (
        <img data-test-id="messageComponentImage" src={image} alt="" />
      ) : undefined}
      {pageType.image ? pageType.image : undefined}

      <div className="relative sm:max-w-xl sm:mx-auto mb-16 sm:mb-0">
        <PhraseePrimaryLogo
          className={cx('text-phraseeOrange mb-10')}
          width={220}
          height={60}
        />

        <h2
          id="test-id-H2"
          className="my-8 text-6xl text-coolGray-800 font-bold"
        >
          {isErrorStaticPage ? pageType.textPrimary : textPrimary}
        </h2>
        <p id="test-id-P" className="mb-8 text-4xl text-coolGray-800">
          {isErrorStaticPage ? pageType.textSecondary : textSecondary}
        </p>

        {(isPageNotFound || isPageUnauthorized) && (
          <p className="text-3xl font-light">{pageType.ctaText}</p>
        )}
        {shouldRenderCta && (
          <div className="text-center" title="Create new experiment">
            <button
              type="button"
              className="create-campaign-link"
              onClick={() => handleClick()}
            >
              <span>
                {isErrorStaticPage ? pageType.ctaText : 'Create new experiment'}
              </span>
            </button>
          </div>
        )}
      </div>
      <AuthFooter showBookDemo={false} />
    </div>
  )
}

export default MessageComponent
